import { Component, Input } from '@angular/core';

@Component({
    selector: 'isophi-table-progress-bar',
    templateUrl: './table-progress-bar.component.html',
    styleUrls: ['./table-progress-bar.component.scss'],
    standalone: false
})
export class TableProgressBarComponent {
  @Input() value = 0;
  @Input() max = 100;

  get percentage(): number {
    return this.max > 0 ? (this.value / this.max) * 100 : 0;
  }
}
